module.exports = {
  draggableOpacity: 0.7,
  outline: 0,

  mouseDownEvent: function (event) {},
  mouseMoveEvent: function (event) {},
  mouseUpEvent: function (event) {},
  clickEvent: function (event) {},

  mouseDown: function (event) {
    this.startPosition = { x: event.pageX, y: event.pageY };
    this.$draggableClone = this.createDraggableClone();
    this.$draggable.css('outline', this.outline);
    this.uppdateDraggableCloneDataPosition(event);
    this.bindDragDrop();

    this.mouseDownEvent(event);
  },

  mouseMove: function (event) {
    const distanceMoved = Math.sqrt(Math.pow(event.pageX - this.startPosition.x, 2) + Math.pow(event.pageY - this.startPosition.y, 2));

    if (distanceMoved > 5) {
      const processDraggable = _.partial(this.processDraggable, event);
      $('#draggingObject').length && _.defer(processDraggable);
    }
  },

  mouseUp: function (event) {
    event.preventDefault();
    const offset = $('#canvas-panel').offset();

    if (this.$draggableClone.length) {
      const cursorPosition = this.getCursorPosition(event);

      if (cursorPosition.x > offset.left) this.mouseUpEvent(event);
      else if (!this.$draggableClone.data('dragging')) this.clickEvent(event);

      this.endDragging();
    }

    // Reset the start position
    this.startPosition = null;
  },

  createDraggableClone: function () {
    const roundingRect = this.$draggable.get(0).getBoundingClientRect();
    const $draggableClone = this.$draggable.clone(true).off();
    $('#draggingObject').remove();

    $draggableClone.attr('id', 'draggingObject');
    $draggableClone.attr('style', this.$draggable.attr('style'));
    $draggableClone.css({
      position: 'absolute',
      left: roundingRect.left,
      top: roundingRect.top,
      width: roundingRect.width,
      height: roundingRect.height,
      'z-index': 5000,
      opacity: '0'
    });

    $draggableClone.find('.tooltip').remove();
    $draggableClone.find('svg *').each(function () {
      const id = $(this).attr('id');
      id && $(this).attr('id', 'clone-' + id);
    });

    $('body').append($draggableClone);

    return $draggableClone;
  },

  uppdateDraggableCloneDataPosition: function (event) {
    const roundingRect = this.$draggable.get(0).getBoundingClientRect();
    const cursorPosition = this.getCursorPosition(event);

    const isImageDragging = this.$draggable[0].tagName === 'IMG';

    const offsetX = isImageDragging
      ? cursorPosition.x - roundingRect.left
      : cursorPosition.x - roundingRect.left - roundingRect.width;

    const offsetY = isImageDragging
      ? cursorPosition.y - roundingRect.top
      : cursorPosition.y - roundingRect.top - roundingRect.height;

    this.$draggableClone.data('offset', {
      x: offsetX / roundingRect.width,
      y: offsetY / roundingRect.height
    });
  },

  bindDragDrop: function () {
    $(window).unbind('mousemove touchmove', this.mouseMove);
    $(window).unbind('mouseup touchend touchcancel', this.mouseUp);
    $(window).on('mousemove touchmove', this.mouseMove);
    $(window).on('mouseup touchend touchcancel', this.mouseUp);
  },

  endDragging: function () {
    this.$draggable.css('outline', 'none');
    this.$draggableClone.remove();

    $(window).unbind('mousemove touchmove', this.mouseMove);
    $(window).unbind('mouseup touchend', this.mouseUp);
  },

  processDraggable: function (event) {
    const offset = this.$draggableClone.data('offset');
    if (!this.$draggableClone.length || !offset) return;

    const roundingRect = this.$draggable.get(0).getBoundingClientRect();
    const unsnappedPosition = getUnsnappedPosition.call(this);

    const dx = Math.abs(unsnappedPosition.x - roundingRect.left);
    const dy = Math.abs(unsnappedPosition.y - roundingRect.top);
    const distance = Math.round(Math.sqrt(dx * dx + dy * dy));

    processPosition.call(this);
    processScale.call(this);

    dx > 122.5 && event.preventDefault();
    distance > 10 && this.$draggableClone.data('dragging', true);
    this.mouseMoveEvent(event);

    function getUnsnappedPosition () {
      const cursorPosition = this.getCursorPosition(event);

      return {
        x: cursorPosition.x - roundingRect.width * offset.x,
        y: cursorPosition.y - roundingRect.height * offset.y
      };
    }

    function processPosition () {
      const isYSnaped = dx < 122.5;
      const isXSnaped = distance < 80;

      const mouseX = isXSnaped ? roundingRect.left : unsnappedPosition.x;

      const mouseY = isYSnaped ? roundingRect.top : unsnappedPosition.y;

      this.$draggableClone.css('left', mouseX);
      this.$draggableClone.css('top', mouseY);
      this.$draggableClone.css(
        'opacity',
        isXSnaped && isYSnaped ? '0' : this.draggableOpacity
      );
    }

    function processScale () {
      const minimumScaleDistance = 130;
      const maximumScaleDistance = 300;

      const maxScale = 2;
      let multi = 1;

      if (distance > minimumScaleDistance) {
        multi +=
          (distance - minimumScaleDistance) /
          (maximumScaleDistance - minimumScaleDistance);

        if (multi > maxScale) multi = maxScale;
      }

      this.$draggableClone.css('transform', 'scale(' + multi + ')');
    }
  },

  getCursorPosition: function (event) {
    if (event.type.indexOf('touch') === 0) {
      const changedTouches = event.originalEvent
        ? event.originalEvent.changedTouches
        : event.changedTouches;

      const retval = {
        x: changedTouches && changedTouches[0].clientX,
        y: changedTouches && changedTouches[0].clientY
      };

      event.clientX = retval.x;
      event.clientY = retval.y;

      return retval;
    }

    return { x: event.clientX, y: event.clientY };
  },

  initDraggable: function () {
    _.bindAll(this, 'mouseMove', 'mouseUp', 'processDraggable');
  }
};
